import {DynamicFilterEntryDto} from "../../models/dynamic-filter/dynamic-filter-entry-dto.model";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {AttributeTypeEnum} from "../../enums/AttributeType";

export class ObjectFilterUtil {

  static readonly PLACEHOLDER = 'DESIGN_B.GLOBAL.TO_SEARCH';

  static readonly SEARCH_TERM = 'searchTerm';

  public static populateFilterEntry(entry: DynamicFilterEntryDto,
                                    filterForm: UntypedFormGroup,
                                    simpleFilterToCount: DynamicFilterEntryDto[],
                                    attributeTypeFilterEntries: Map<AttributeTypeEnum, DynamicFilterEntryDto>,
                                    basicInfoFilterEntries: DynamicFilterEntryDto[]): DynamicFilterEntryDto[] {
    switch (entry.filterName) {
      case ObjectFilterUtil.SEARCH_TERM: {
        filterForm.addControl(entry.id.toString(), new UntypedFormControl([]));
        filterForm.addControl('show_' + entry.id, new UntypedFormControl(true));
        simpleFilterToCount.push(entry);
        return [entry];
      }
    }
  }

  public static initFilterFormGroup(filterForm: UntypedFormGroup, filterEntries: DynamicFilterEntryDto[]) {

    filterEntries.forEach(entry => {
      ObjectFilterUtil.populateFilterEntry(entry, filterForm, [], new Map(), []);
    });
  }
}
